module.exports = __webpack_public_path__ + "img/suites-2.20a04574.jpg";